import { useMemo, useState } from "react";
import { CustomAPIs } from "./CustomAPIs/CustomAPIs";
import { Extraction } from "./Extraction/Extraction";
import { TransferAgents } from "../TransferSettings/TransferAgents";

import { SMSTriggers } from "../CustomActions/SMSTriggers/SMSTriggers";
import { EndCallTriggers } from "../CustomActions/EndCallTriggers/EndCallTriggers";
import { StopCallRecordingTriggers } from "../CustomActions/StopCallRecordingTriggers/StopCallRecordingTriggers";
import RealTimeBookings from "./RealTimeBookingsV2";
import Webhooks from "./WebhooksV2";
import { CRMSearchEnabled } from "../RAG/CRMSearchV2/CRMSearch";
import { Extractions } from "./ExtractionV2/Extractions";
import { ParentLayout } from "./components/ParentLayout";
import { SectionLayout } from "./components/SectionLayout";
import { SectionItem } from "./components/SectionItem";
import { MainLayout } from "./components/MainLayout";
import { getAvailableSlotTags } from "../AssistantSettings/TimeZoneSettingsV2/TimeSlots";
import WhatsappTriggers from "../CustomActions/WhatsappTriggers/WhatsappTriggers";
import {
  PiWebhooksLogoLight,
  PiCalendarLight,
  PiPhoneTransfer,
  PiPlugs,
} from "react-icons/pi";
import { LuScanText } from "react-icons/lu";
import {
  RiContactsBookLine,
  RiWhatsappLine,
} from "react-icons/ri";
import { MdCallEnd, MdOutlineSms } from "react-icons/md";
import { FaRegStopCircle } from "react-icons/fa";

enum TOOL {
  WEBHOOKS = "Webhooks",
  EXTRACTION = "Extraction",
  CUSTOM_API = "Custom API",
  TRANSFER_AGENTS = "Transfer Agents",
  CALENDAR_APPOINTMENTS = "Calendar Appointments",
  CONTACTS_SEARCH = "Contacts Search",
  TRIGGER_SMS = "SMS Triggers",
  TRIGGER_WHATSAPP = "WhatsApp Triggers",
  END_CALL = "End Call Triggers",
  STOP_CALL_RECORDING = "Stop Call Recording Triggers",
}

const ToolComponent = {
  [TOOL.CUSTOM_API]: (props) => <CustomAPIs {...props} />,
  // [TOOL.EXTRACTION]: (props) => <Extraction {...props} />,
  [TOOL.EXTRACTION]: (props) => <Extractions {...props} />,
  [TOOL.WEBHOOKS]: (props) => <Webhooks {...props} />,
  [TOOL.TRANSFER_AGENTS]: (props) => <TransferAgents {...props} />,
  [TOOL.CONTACTS_SEARCH]: (props) => <CRMSearchEnabled {...props} />,
  [TOOL.CALENDAR_APPOINTMENTS]: (props) => <RealTimeBookings {...props} />,
  [TOOL.TRIGGER_SMS]: (props) => <SMSTriggers {...props} />,
  [TOOL.TRIGGER_WHATSAPP]: (props) => <WhatsappTriggers {...props} />,
  [TOOL.END_CALL]: (props) => <EndCallTriggers {...props} />,
  [TOOL.STOP_CALL_RECORDING]: (props) => (
    <StopCallRecordingTriggers {...props} />
  ),
};

export const ToolIcons = {
  [TOOL.WEBHOOKS]: <PiWebhooksLogoLight />,
  [TOOL.EXTRACTION]: <LuScanText />,
  [TOOL.TRANSFER_AGENTS]: <PiPhoneTransfer />,
  [TOOL.CALENDAR_APPOINTMENTS]: <PiCalendarLight />,
  [TOOL.CONTACTS_SEARCH]: <RiContactsBookLine />,
  [TOOL.CUSTOM_API]: <PiPlugs />,
  [TOOL.END_CALL]: <MdCallEnd />,
  [TOOL.TRIGGER_SMS]: <MdOutlineSms />,
  [TOOL.TRIGGER_WHATSAPP]: <RiWhatsappLine />,
  [TOOL.STOP_CALL_RECORDING]: <FaRegStopCircle />,
};

function VoiceAssistantTools(props) {
  const [activeTool, setActiveTool] = useState(TOOL.WEBHOOKS);

  const tools = Object.values(TOOL).reduce((acc, tool) => {
    return [...acc, { name: tool, href: "#", current: tool === activeTool }];
  }, []);

  const availableSlotTags = useMemo(() => {
    const { _id, ...restScheduleData } = props.timezoneSettings.scheduleData;
    return getAvailableSlotTags(restScheduleData);
  }, [props.timezoneSettings]);

  return (
    <ParentLayout>
      <SectionLayout>
        {tools.map((tool) => (
          <SectionItem
            sectionName={tool.name}
            isActive={tool.current}
            icon={ToolIcons[tool.name]}
            onSectionClick={() => setActiveTool(tool.name)}
          />
        ))}
      </SectionLayout>
      <MainLayout>
        {ToolComponent[activeTool]({
          ...props,
          availableSlotTags,
        })}
      </MainLayout>
    </ParentLayout>
  );
}

export { VoiceAssistantTools };
